import React, { useEffect, useState } from "react";
import Header from "./homepage/Header";
import TcNav from "../components/tcs/TcNav";
import DriverNav from "../components/drivers/DriverNav";
import "../styles/homepage.css"

const Laws = () => {
  const [laws, setLaws] = useState([]);
  const auth = localStorage.getItem("user");
  const user = JSON.parse(auth);
  const type = user && user[0].userType;
  const getLaws = async () => {
    try {
      const response = await fetch("http://localhost:8000/laws");
      const data = await response.json();
      setLaws(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getLaws();
  }, []);

  return (
    <div className="text-white text-center">
      {auth ? auth && (type === "admin" || type ==="super") ? <TcNav /> : <DriverNav /> : <Header />}

      {!auth && <h3 className="mt-4 mb-4">Traffic Violations and Fine List</h3>}
      {auth && <h3 className="mt-5 mb-5 dummy">dummy</h3>}

      <div className="container">
        <table className="table table-bordered">
          <thead>
            <tr>
              {/* <th style={{ width: "100px" }}>ID</th> */}
              <th style={{ width: "50%" }}>Violations</th>
              <th style={{ width: "50%" }}>Fine</th>
            </tr>
          </thead>
          <tbody>
            {laws.map((law) => (
              <tr key={law.id}>
                {/* <td>{law.id}</td> */}
                <td>{law.violations}</td>
                <td>{law.fine}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="fs-6">
        <a
          className="text-white link-offset-2 link-underline link-underline-opacity-0"
          href="https://www.gazette.sc/sites/default/files/2023-10/Act%2014%20-%202023%20-%20Road%20Transport%20%28Amendment%29%20Act%202023.pdf"
        >
          Road Transport (Amendment) Act, 2023
        </a>
      </p>
    </div>
  );
};

export default Laws;
